/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S6_Li1Inputs */

const tr_mesafeli_s6_li1 = /** @type {(inputs: Mesafeli_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Süre bitiminden 7 (yedi) gün ve 1 (bir) gün önce Müşteri'ye kayıtlı e-posta adresinden hatırlatma yapılır. Bu hatırlatma; bitiş tarihini, yeni dönem bedelini ve ödeme bağlantısını içerir.`)
};

const en_mesafeli_s6_li1 = /** @type {(inputs: Mesafeli_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 (seven) days and 1 (one) day before the end of the term a reminder is sent to the Customer's registered email address. The reminder contains the end date, the price of the new term and the payment link.`)
};

const de_mesafeli_s6_li1 = /** @type {(inputs: Mesafeli_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 (sieben) Tage und 1 (einen) Tag vor dem Ende erhält der Kunde an die hinterlegte E-Mail-Adresse eine Erinnerung mit Enddatum, Preis der neuen Laufzeit und Zahlungs-Link.`)
};

const ru_mesafeli_s6_li1 = /** @type {(inputs: Mesafeli_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За 7 (семь) дней и за 1 (один) день до окончания срока Клиенту на зарегистрированный адрес электронной почты направляется напоминание. Оно содержит дату окончания, стоимость нового срока и ссылку для оплаты.`)
};

/**
* | output |
* | --- |
* | "7 (seven) days and 1 (one) day before the end of the term a reminder is sent to the Customer's registered email address. The reminder contains the end date, ..." |
*
* @param {Mesafeli_S6_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s6_li1 = /** @type {((inputs?: Mesafeli_S6_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S6_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s6_li1(inputs)
	if (locale === "de") return de_mesafeli_s6_li1(inputs)
	if (locale === "ru") return ru_mesafeli_s6_li1(inputs)
	return tr_mesafeli_s6_li1(inputs)
});